export interface Token {
  idToken: string
  accessToken: string
  refreshToken: string
}

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const SET_PARTNER = 'SET_PARTNER'
export const SET_ROLE = 'SET_ROLE'
export const SET_USER = 'SET_USER'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_CODE = 'SET_CODE'
